// --- INJECTED ---
import { getI18n } from '@/core/i18n';

const i18n = getI18n();
// --- /INJECTED ---

const breadCrumb = [
  {
    label: i18n.t('misc.catalogs_categories'),
    route: { name: 'catalogs-categories$catalogs-categories' },
  },
  {
    label: i18n.t('common.category'),
    route: { name: 'catalogs-categories$category' },
  },
  {
    label: i18n.t('common.catalog'),
    route: { name: 'catalogs-categories$catalog' },
  },
  {
    label: i18n.t('misc.new_catalog'),
    route: { name: 'catalogs-categories$create-catalog' },
  },
  {
    label: i18n.t('misc.new_category'),
    route: { name: 'catalogs-categories$create-category' },
  },
];

export default [
  {
    path: '/catalogs-categories',
    name: 'catalogs-categories$catalogs-categories',
    component: () => import('@/apps/catalogs-categories/views/CatalogsCategories'),
    redirect: { name: 'catalogs-categories$catalogs' },
    meta: {
      breadCrumb: breadCrumb.slice(0, 1),
      title: i18n.t('misc.catalogs_categories'),
    },
    children: [
      {
        path: 'catalogs',
        name: 'catalogs-categories$catalogs',
        component: () => import('@/apps/catalogs-categories/views/Catalogs/Catalogs'),
        meta: {
          breadCrumb: breadCrumb.slice(0, 1),
          title: i18n.t('common.catalogs'),
        },
      },
      {
        path: 'categories',
        name: 'catalogs-categories$categories',
        component: () => import('@/apps/catalogs-categories/views/Categories/Categories'),
        alias: 'catalogs',
        meta: {
          breadCrumb: breadCrumb.slice(0, 1),
          title: i18n.t('common.categories'),
        },
      },

    ],
  },
  {
    path: '/catalog/create',
    name: 'catalogs-categories$create-catalog',
    component: () => import('@/apps/catalogs-categories/views/Catalogs/Catalog/Catalog'),
    meta: {
      breadCrumb: [breadCrumb[0], breadCrumb[3]],
      title: i18n.t('misc.new_catalog'),
    },
  },
  {
    path: '/category/create',
    name: 'catalogs-categories$create-category',
    component: () => import('@/apps/catalogs-categories/views/Categories/Category/Category'),
    meta: {
      breadCrumb: [breadCrumb[0], breadCrumb[4]],
      title: i18n.t('misc.new_category'),
    },
  },
  {
    path: '/catalogs/:id',
    name: 'catalogs-categories$catalog',
    component: () => import('@/apps/catalogs-categories/views/Catalogs/Catalog/Catalog'),
    meta: {
      breadCrumb: [breadCrumb[0], breadCrumb[2]],
      title: i18n.t('common.catalog'),
    },
  },
  {
    path: '/categories/:id',
    name: 'catalogs-categories$category',
    component: () => import('@/apps/catalogs-categories/views/Categories/Category/Category'),
    meta: {
      breadCrumb: breadCrumb.slice(0, 2),
      title: i18n.t('common.category'),
    },
  },


];
